<header class="navbar flex items-center justify-center">
  <div class="w-full max-w-4xl flex items-center justify-between px-6">
    <a href="/">
      <img
        role="presentation"
        class="img-responsive"
        src="/assets/images/wgu-logo.svg"
        width="150"
      />
      <span class="sr-only">Home</span>
    </a>
    <h1 class="sr-only">Western Governors University Account Management</h1>
    <!-- <a
        *ngIf="(isAuthenticated$ | async) === false"
        hidden=true
      >
      Logged in as {{username}}
      </a>-->
    <!--<div style="padding-right: 10px; padding-top: 10px; min-height: 50px">
      <button
        *ngIf="(isAuthenticated$ | async) === false"
        class="btn btn-primary"
        id="home"
        type="button" (click)="home()" style="float: right; color: darkgray;">
        Home
      </button>
      <button
        *ngIf="isAuthenticated$ | async"
        class="btn btn-default"
        id="home"
        type="button" (click)="home()" style="float: right">
        Home
      </button>
    </div> -->
  </div>
</header>
